import React, { Component } from 'react'
import MetaPropertiesTableDynamic from './MetaPropertiesTableDynamic'
import { MetaPropertiesTableStatic } from './MetaPropertiesTableStatic'

export class MetaPropertiesAccordion extends Component {
    
    render() {
        return (
            <div id="accordion" className="accordion">
                <div className="card">
                <div className="card-header" id={this.props.index}>
                    <a data-toggle="collapse" data-target={"#collapse-"+this.props.index} aria-expanded="false" aria-controls={"collapse-"+this.props.index}>{this.props.eleCategory}  ---  {this.props.elemName}</a>
                </div>
                <div id={"collapse-"+this.props.index} className="collapse" aria-labelledby={this.props.index} data-parent="#accordion">
                    <div className="card-body">
                        <h3>Static Properties</h3>
                        <MetaPropertiesTableStatic statProps = {this.props.statProps} propertyValues={this.props.propertyValues}/>
                        <h3>Dynamic Properties</h3> <h2 data-locked={this.props.locked}>{this.props.locked}</h2>
                        <MetaPropertiesTableDynamic tag={this.props.elemName} locked={this.props.locked}/>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default MetaPropertiesAccordion
